import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { LISCase } from "pwapi";

import { selectFeatureFlag } from "shared/reducers/sysReducer";

import { scanBlock } from "app/actions/blockActions";
import { scanSlide } from "app/actions/slideActions";
import { useAppDispatch, useAppSelector } from "app/hooks";

import { useBarcodePrintingCallbacks } from "./useBarcodePrintingCallbacks";
import { useSelectedLabStation } from "./useSelectedLabStation";

const useCuttingOnScanCallbacks = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const selectedLabStation = useSelectedLabStation();
  const autoPrint = !useAppSelector((state) =>
    selectFeatureFlag(state, "skipAutomaticBarcodePrinting")
  );

  const { printSlide } = useBarcodePrintingCallbacks();

  const onScanBlock = useCallback(
    (id: number, navigateAfter: boolean = true) => {
      const promise = dispatch(
        scanBlock({ id, parentLookupLabStationId: selectedLabStation.id })
      );

      if (autoPrint) {
        promise.then((response: LISCase) => {
          const newSlideIds = response._meta?.created?.slides || [];
          printSlide(newSlideIds, response.id as number);
          return response;
        });
      }

      if (navigateAfter) {
        promise.then((response: LISCase) => {
          navigate(`/station/cutting/${id}/`);
          return response;
        });
      }

      return promise;
    },
    [selectedLabStation.id]
  );

  const onScanSlide = useCallback(
    (id: number, navigateAfter: boolean = true) => {
      const promise = dispatch(
        scanSlide({ id, parentLookupLabStationId: selectedLabStation.id })
      );
      if (navigateAfter) {
        promise.then((response: LISCase) => {
          const blockId = response.slides.find(
            (s) => s.id === id
          )?.block_obj_id;
          navigate(`/station/cutting/${blockId}/`);
          return response;
        });
      }
      return promise;
    },
    [selectedLabStation.id]
  );

  return {
    onScanBlock,
    onScanSlide,
  };
};

export default useCuttingOnScanCallbacks;
